import apiService from "@/services/apiService";

const actions = {
  getErrorLogs({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService
        .post("log-data/find-with-paging", payload)
        .then(response => {
          commit("setErrorLogs", response.data.data);
          resolve(response.data.data);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  }
};

export default actions;
